import { dispatch } from "../redux/store";
import { addToast } from "../redux/toast";
import axios from "axios";

const apiRequest = async (
  props,
  requestType,
  useToken = true,
  headers = {}
) => {
  try {
    const token = localStorage.getItem("token");
    if (useToken) headers["Authorization"] = `Bearer ${token}`;
    let config = { headers };
    const resp = await axios[requestType](...props, config);
    return resp;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(
        addToast({
          type: "error",
          message: "Your token has expired. Please log in again.",
        })
      );
    }
  }
};

export const customApiCall = {
  delete: async function ({ headers = {}, url, useToken = true }) {
    const props = [url];
    const resp = await apiRequest(props, "delete", useToken);
    return resp.data;
  },
  get: async function ({ headers = {}, url, useToken = true }) {
    const props = [url];
    const resp = await apiRequest(props, "get", useToken);
    return resp?.data;
  },
  head: async function ({ headers = {}, url, useToken = true }) {
    const props = [url];
    const resp = await apiRequest(props, "head", useToken);
    return resp;
  },
  patch: async function ({ data, headers = {}, url, useToken = true }) {
    const props = [url, data];
    const resp = await apiRequest(props, "patch", useToken);
    return resp?.data;
  },
  put: async function ({ data, headers = {}, url, useToken = true }) {
    const props = [url, data];
    const resp = await apiRequest(props, "put", useToken);
    return resp?.data;
  },
  post: async function ({ data, headers = {}, url, useToken = true }) {
    const props = [url, data];
    const resp = await apiRequest(props, "post", useToken, headers);
    return resp?.data;
  },
};
